import React from "react";
import T from "prop-types";

import Toolbar, { ToolbarItem } from "2g-toolbar";

import useMessages from "b2b/components/zadosti-odbaveni-grid/i18n/useMessages";

export function ZadostiOdbaveniToolbar({
  onClickPotvrdit,
  onClickZamitnout,
  visible = false,
  gridRef
}) {
  const messages = useMessages();
  return visible ? (
    <Toolbar float visibilityRef={gridRef} bottom>
      <ToolbarItem inverse onClick={onClickPotvrdit} type="success">
        {messages.toolbarItemAcceptLabel()}
      </ToolbarItem>
      <ToolbarItem inverse onClick={onClickZamitnout} type="danger">
        {messages.toolbarItemDeclineLabel()}
      </ToolbarItem>
    </Toolbar>
  ) : undefined;
}

ZadostiOdbaveniToolbar.propTypes = {
  onClickPotvrdit: T.func.isRequired,
  onClickZamitnout: T.func.isRequired,
  visible: T.bool.isRequired,
  gridRef: T.object.isRequired
};

export default React.memo(ZadostiOdbaveniToolbar);
